import { createRouter, createWebHistory } from 'vue-router'

import { isMobile } from '@/network/device'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => !isMobile() ? import('../views/index/index.vue') : import('../views/index/indexmobile.vue'),
  },
  {
    path: '/km',
    name: "km",
    component: () => !isMobile() ? import('../views/km/km.vue') : import('../views/km/kmmobile.vue'),
  },
  {
    path: '/lit',
    name: "lit",
    component: () => !isMobile() ? import('../views/lit/lit.vue') : import('../views/lit/litmobile.vue'),
  },
  {
    path: '/end',
    name: 'end',
    component: () => !isMobile() ? import('../views/end/end.vue') : import('../views/end/end.vue'),
  },
  {
    path: '/tos_cn',
    name: "tos_cn",
    component: () => import('../views/index/tos_cn.vue'),
  },
  {
    path: '/tos_en',
    name: "tos_en",
    component: () => import('../views/index/tos_en.vue'),
  },
  {
    path: '/policy_cn',
    name: "policy_cn",
    component: () => import('../views/index/policy_cn.vue'),
  },
  {
    path: '/policy_en',
    name: "policy_en",
    component: () => import('../views/index/policy_en.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 动态切换 favicon
router.afterEach((to) => {
  const favicon = document.getElementById('dynamic-favicon');
  const shortcutIcon = document.querySelector('link[rel="shortcut icon"]')
  const timestamp = Date.now(); // 添加时间戳防止缓存

  let icoPath = '/favicon.ico'; // 默认ico

  if (to.path.includes('/km')) {
    icoPath = '/km.ico';
  } else if (to.path.includes('/lit')) {
    icoPath = '/lit.ico';
  }

  if (favicon) favicon.href = `${icoPath}?t=${timestamp}`;
  if (shortcutIcon) shortcutIcon.href = `${icoPath}?t=${timestamp}`;
});

export default router
